import type { RouteLocationNormalized, RouteRecordNormalized } from 'vue-router'
import type { App, Plugin } from 'vue'

import { unref } from 'vue'
import { isObject } from '/@/utils/is'
import { isArray } from 'lodash-es'

export function noop() {}

/**
 * @description:  Set ui mount node
 */
export function getPopupContainer(node?: HTMLElement): HTMLElement {
    return (node?.parentNode as HTMLElement) ?? document.body
}

/**
 * Add the object as a parameter to the URL
 * @param baseUrl url
 * @param obj
 * @returns {string}
 * eg:
 *  let obj = {a: '3', b: '4'}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4
 */
export function setObjToUrlParams(baseUrl: string, obj: any): string {
    let parameters = ''
    for (const key in obj) {
        parameters += `${key}=${encodeURIComponent(obj[key])}&`
    }
    parameters = parameters.replace(/&$/, '')
    return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters
}

// 深度合并
export function deepMerge<T = any>(src: any = {}, target: any = {}): T {
    let key: string
    for (key in target) {
        const isObj = isObject(src[key]) && isObject(target[key])
        src[key] = isObj ? deepMerge(src[key], target[key]) : (src[key] = target[key])
    }
    return src
}

export function openWindow(
    url: string,
    opt?: { target?: TargetContext | string; noopener?: boolean; noreferrer?: boolean },
) {
    const { target = '__blank', noopener = true, noreferrer = true } = opt || {}
    const feature: string[] = []

    noopener && feature.push('noopener=yes')
    noreferrer && feature.push('noreferrer=yes')

    window.open(url, target, feature.join(','))
}

// dynamic use hook props
export function getDynamicProps<T, U>(props: T): Partial<U> {
    const ret: Recordable = {}

    Object.keys(props).forEach((key) => {
        ret[key] = unref((props as Recordable)[key])
    })

    return ret as Partial<U>
}

export function getRawRoute(route: RouteLocationNormalized): RouteLocationNormalized {
    if (!route) return route
    const { matched, ...opt } = route
    return {
        ...opt,
        matched: (matched
            ? matched.map((item) => ({
                  meta: item.meta,
                  name: item.name,
                  path: item.path,
              }))
            : undefined) as RouteRecordNormalized[],
    }
}

export function withInstall<T>(component: T, alias?: string) {
    const comp = component as any
    comp.install = (app: App) => {
        app.component(comp.name || comp.displayName, component)
        if (alias) {
            app.config.globalProperties[alias] = component
        }
    }
    return component as T & Plugin
}

/**
 *  数组分类
 * @param data
 * @param key
 * @returns
 */

export function listsByKeysPoly(data: Recordable[], key: string | string[]) {
    const isMultiKey = isArray(key)

    const __data = (data || []).reduce((result, item) => {
        const values = isMultiKey ? key.map((k) => item[k]).join('') : item[key]

        if (result[values]) {
            result[values].push({ ...item })
        } else {
            result[values] = [{ ...item }]
        }
        return result
    }, {})

    return __data
}

/**
 * 清除空的value
 * @param obj
 * @returns
 */
export function delEmptyQueryNodes(obj = {}) {
    Object.keys(obj).forEach((key) => {
        const value = obj[key]
        value && typeof value === 'object' && delEmptyQueryNodes(value)
        ;(value === '' || value === null || value === undefined) && delete obj[key]
    })
    return obj
}

/**
 * 后台类型
 * @param data
 * @returns
 */
export function createList(data) {
    return data.map((item) => {
        const keys = Object.keys(item)
        const values = Object.values(item) as string[]
        const record = {
            label: values[0],
            value: keys[0],
        }
        return record
    })
}
